import React from 'react';
import Modal from 'react-bootstrap/Modal';

// Add show and handleClose as props that will be passed from parent
const Popup = ({ show, handleClose, popupTitle, popupClass, popupSize, data, children }) => {
    return (
        <Modal
            show={show}
            onHide={handleClose}
            dialogClassName={`modal-${popupSize} ${popupClass}`}
            backdrop="false"
            keyboard={true}
        >
            <Modal.Header closeButton>
                <Modal.Title>{popupTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {children}
            </Modal.Body>
        </Modal>
    );
};

// For usage reference
// const ParentComponent = () => {
//     const [showPopup, setShowPopup] = useState(false);
//     const handleClose = () => setShowPopup(false);
//     const handleOpen = () => setShowPopup(true);
//
//     return (
//         <>
//             <button onClick={handleOpen}>Open Popup</button>
//             <Popup show={showPopup} handleClose={handleClose} />
//         </>
//     );
// }

export default Popup
